import { render, staticRenderFns } from "./SpaceScoring.vue?vue&type=template&id=95f5fee6&scoped=true&"
import script from "./SpaceScoring.vue?vue&type=script&lang=js&"
export * from "./SpaceScoring.vue?vue&type=script&lang=js&"
import style0 from "./SpaceScoring.vue?vue&type=style&index=0&id=95f5fee6&prod&lang=scss&scoped=true&"
import style1 from "./SpaceScoring.vue?vue&type=style&index=1&id=95f5fee6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f5fee6",
  null
  
)

export default component.exports